<form *ngIf="noteFormGroup" [formGroup]="noteFormGroup">
  <div class="grid">
    <div class="col-12 input-field">
      <label for="date">Fecha</label>
      <strong>{{noteFormGroup.get('date')?.value| date: 'dd/MM/yyyy HH:mm'}}</strong>
    </div>
      <div class="col-12 input-field">
          <label for="notes">Notas</label>
          <textarea pTextarea id="notes" rows="5" formControlName="notes" class="p-inputtext" d-form-field-error></textarea>
      </div>
      <div *ngIf="caseNoteFilesImages.length > 0" class="col-12 grid">
        <div *ngFor="let file of caseNoteFilesImages" class="col-12  md:col-4 lg:col-4 xl:col-3 ">
          <div *ngIf="fileIsAnImage(file.file)"
              style="border: 1px solid #e9e9e9; padding: 5px; border-radius: 10px; height: 120px; overflow: hidden;cursor: pointer"  (click)="downloadFile(file.fileId)">
              <img [src]="imagesUrl + file.fileId + '/download'" alt="{{file.file.fileName}}"
                  class="w-full" />
              <!--<div class="flex justify-content-between align-items-center mt-1">
                  <span>{{file.file.fileName}}</span>
              </div>-->
          </div>          
      </div>
      <div *ngIf="caseNoteFilesDocuments.length > 0" class="grid col-12">
        <div class="ml-2">
          <div *ngFor="let file of caseNoteFilesDocuments" style="display: flex;vertical-align: middle;align-items: center;cursor: pointer;margin-bottom: 5px;" (click)="downloadFile(file.fileId)">
              <i class="pi pi-file" style="font-size: 25px;"></i>
              <span>{{file.file.fileName}}</span>
          </div>  
        </div>        
      </div>
      </div>
      <div class="col-12">
        <p-button *ngIf="editable" label="Añadir archivo" icon="pi pi-plus" (click)="editCaseNotesFile(null)" />
      </div>
  </div>

  <div class="mt-4 flex justify-content-between">     
      <div class="flex gap-2">
          <p-button *ngIf="editable" label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
          <p-button *ngIf="editable" label="Guardar" icon="pi pi-check" styleClass="p-ml-2"  (click)="save()"></p-button>
      </div>
  </div>
</form>